import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import { fromJS } from "immutable"
import { Form, actions } from "react-redux-form/immutable"

import Loading from "components/Loading"
import ConfirmDialog from "components/ConfirmDialog"

import FormHeader from "./form-header"
import FormStudents from "./form-students"
import { saveGrades, submitGrades } from "./actions"

class FormContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showConfirm: false,
      error: null,
    }
  }

  componentDidMount() {
    const { dispatch, model } = this.props
    dispatch(actions.change("classState", model))
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.offeringGroupID !== this.props.offeringGroupID) {
      this.props.dispatch(actions.change("classState", nextProps.model))
    }
  }

  _showConfirm = () => {
    this.setState({
      showConfirm: true,
    })
  }

  _hideConfirm = () => {
    this.setState({
      showConfirm: false,
    })
  }

  _onSave = () => {
    const { __classState, offeringGroupID, dispatch } = this.props
    let payload = fromJS([])

    // submit not submitted students
    __classState.get("students").map(item => {
      if (!item.getIn(["grade_submission_id", "Valid"])) {
        payload = payload.push(item)
      }
      return true
    })

    dispatch(saveGrades(offeringGroupID, payload)).then(res => {
      if (!res.error) {
        dispatch(actions.change("classState", fromJS(res.payload || {})))
      }
    })
  }

  _onConfirm = () => {
    const { __classState, offeringGroupID, dispatch } = this.props
    let payload = fromJS([])
    let hasError = false

    // submit checked students
    __classState.get("students").map(item => {
      if (item.get("is_checked")) {
        if (!item.get("fg") && !item.get("re")) {
          hasError = true
          this.setState({
            error:
              "There are some checked students with incomplete grades. Please review.",
          })
        }
        payload = payload.push(item)
      }
      return true
    })
    if (!hasError) {
      dispatch(submitGrades(offeringGroupID, payload)).then(res => {
        if (!res.error) {
          dispatch(actions.change("classState", fromJS(res.payload || {})))
          this._hideConfirm()
        }
      })
    } else {
      this._hideConfirm()
    }
  }

  _renderConfirm() {
    const { showConfirm } = this.state
    const { pending } = this.props

    if (!showConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        msg="Please confirm your submission. Once submitted, you can no longer edit these checked grades."
        closeDialog={this._hideConfirm}
        confirmAction={this._onConfirm}
        btnClass="btn-success"
        pending={pending}
      />
    )
  }

  render() {
    const { error } = this.state
    const { __classState, __pending, offeringGroupID } = this.props
    let disableSubmit = true
    let countChecked = 0
    if (__classState.size === 0) {
      return <Loading />
    }

    // loop through subjects to see if anything has checked
    __classState.get("students").map(item => {
      if (item.get("is_checked")) {
        disableSubmit = false
        countChecked++
      }
      return true
    })

    return (
      <Form model="classState" className="grid-form">
        <fieldset className="m-b-20 text-right" disabled={__pending}>
          <button
            className="btn btn-success"
            disabled={disableSubmit}
            onClick={this._showConfirm}
          >
            Submit Checked Grades [{countChecked}]
          </button>{" "}
          <button onClick={this._onSave} className="btn btn-info">
            Save Grades
          </button>
        </fieldset>
        {!!error && <div className="alert alert-danger">{error}</div>}
        <FormHeader model={__classState.get("header")} />
        <FormStudents
          model={__classState.get("students")}
          offeringGroupID={offeringGroupID}
        />
        {this._renderConfirm()}
      </Form>
    )
  }
}

FormContainer.propTypes = {
  __classState: PropTypes.object,
  offeringGroupID: PropTypes.string,
  model: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __classState: state.classState,
    __pending: state.grade.get("pending"),
  }
}

export default connect(mapStateToProps)(FormContainer)



// WEBPACK FOOTER //
// ./src/containers/Grades/form-container.js